'use strict';
const fs = require('fs');

module.exports = fp => new Promise(resolve => {
	fs.access(fp, err => {
		resolve(!err);
	});
});

module.exports.sync = fp => {
	try {
		fs.accessSync(fp);
		return true;
	} catch (err) {
		return false;
	}
};



//////////////////
// WEBPACK FOOTER
// ./~/path-exists/index.js
// module id = 994
// module chunks = 0